import { render, staticRenderFns } from "./reminder.vue?vue&type=template&id=49005a36&"
import script from "./reminder.vue?vue&type=script&lang=js&"
export * from "./reminder.vue?vue&type=script&lang=js&"
import style0 from "./reminder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports